import script from "./LinksPage.vue?vue&type=script&setup=true&lang=js"
export * from "./LinksPage.vue?vue&type=script&setup=true&lang=js"

import "./LinksPage.vue?vue&type=style&index=0&id=929e4116&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-929e4116"]])

export default __exports__